import styles from "./styles.module.css";

interface PopupProps {
  title: string;
  message: React.ReactNode;
  btnText: string;
  cancelText: string;
  hideCancel: boolean;
  noOfAttempts: number;
  onClickBtn: (text: string) => void;
  icon: React.ReactNode;
}
const PopUp: React.FC<Partial<PopupProps>> = ({
  btnText,
  message,
  noOfAttempts,
  onClickBtn,
  title,
  cancelText,
  hideCancel,
  icon,
}) => {
  return (
    <div className={styles.popupWrapper}>
      {icon && icon}
      <h4>
        <strong>{title}</strong>
      </h4>
      <p>{message}</p>
      <div className={styles.ctrlBtns}>
        {!hideCancel && (
          <button className="whiteBtn" onClick={() => onClickBtn(cancelText || "Cancel")}>
            {cancelText || "Cancel"}
          </button>
        )}
        {btnText && (
          <button onClick={() => onClickBtn(btnText)}>{btnText}</button>
        )}
      </div>
      {noOfAttempts && (
        <span>
          You have <strong>{noOfAttempts} attempts</strong> remaining
        </span>
      )}
    </div>
  );
};

export default PopUp;
